module.exports = __webpack_public_path__ + "img/full5-min.9ab23f95.png";